import React, { useEffect, useState } from 'react';
import { Table, Space } from 'antd';
import AddSeason from '../components/AddSeason';
import { seasonCols } from '../utils/DataUtils';
import { api } from '../AppConfig';
import * as Setting from '../utils/AuthUtils';
import { motion } from 'motion/react';

function Seasons(props) {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [leagues, setLeagues] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        Setting.getUserinfo()
        .then(
          (result) => {
            setIsAdmin(result.payLoad.isAdmin);
            if (props.participant && props.participant.value && props.participants.value.payLoad !== null) {
              
            }
          },
          (error) => {
            console.warn(error);
            setIsAdmin(false);
          }
        )
        fetch(api.seasons().list().href, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setItems(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        fetch(api.leagues().list().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setLeagues(result.payLoad);
            },
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
      }, [])

      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
        <h1>
            Seasons
        </h1>
        <Table
            columns={seasonCols} 
            dataSource={items} 
            pagination={false} 
            loading={!isLoaded}/>
            { Setting.isLoggedIn() && isAdmin &&
              <AddSeason leagues={leagues} />
            }
        </motion.div>
    );
}

export default Seasons;